import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { parse, stringify } from '../../util/urlHelpers';

export default function(params) {
  const { onChange, searchParamName, onValueReset } = params || {};

  const location = useLocation();
  const { pathname, search, state } = location;
  const history = useHistory();

  const handleValueChanged = useCallback(
    value => {
      const parsedSearch = parse(search);
      const { page, ...rest } = parsedSearch;

      const searchString = `?${stringify({ ...rest, [searchParamName]: value })}`;

      history.replace(`${pathname}${searchString}`, state);
      onChange?.(value, searchString);
    },
    [history, onChange, search, searchParamName, pathname]
  );

  const handleResetFilter = useCallback(() => {
    const parsedSearch = parse(search);
    const { page, [searchParamName]: prevValue, ...rest } = parsedSearch;

    const searchString = `?${stringify(rest)}`;

    history.replace(`${pathname}${searchString}`, state);
    onValueReset?.('', searchString);
  }, [history, onValueReset, search, searchParamName, pathname]);

  return { handleValueChanged, handleResetFilter, search };
}
